// extracted by mini-css-extract-plugin
export default {"card_img":"CardCourse_card_img__S+Q6c"};